import { __decorate, __metadata } from "tslib";
import _ from 'lodash';
import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
export const DEFAULT_MAXNUMBE = 99999999;
let BInputNumberImpl = class BInputNumberImpl extends Vue {
    get Value() {
        return _.toString(this.value);
    }
    get InputListeners() {
        return _.omit(this.$listeners, 'change');
    }
    onChange(value) {
        let valueEmit = null;
        if (_.isEmpty(_.trim(value))) {
            if (!_.isNil(this.min)) {
                valueEmit = this.min;
            }
        }
        else {
            valueEmit = this.formatter(value);
        }
        this.$emit('update', valueEmit);
        const input = this.inputRef.$refs.input;
        input.setAttribute('value', _.toString(valueEmit));
    }
    formatter(value) {
        const formated = _.toInteger(value);
        if (!_.isNil(this.min) && formated < this.min) {
            return this.min;
        }
        if (!_.isNil(this.max) && formated > this.max) {
            return this.max;
        }
        return formated;
    }
};
__decorate([
    Prop({
        type: [Number, String],
    }),
    __metadata("design:type", Number)
], BInputNumberImpl.prototype, "value", void 0);
__decorate([
    Prop({
        type: Number,
        required: false,
    }),
    __metadata("design:type", Number)
], BInputNumberImpl.prototype, "min", void 0);
__decorate([
    Prop({
        type: Number,
        default: DEFAULT_MAXNUMBE,
    }),
    __metadata("design:type", Number)
], BInputNumberImpl.prototype, "max", void 0);
__decorate([
    Ref(),
    __metadata("design:type", Object)
], BInputNumberImpl.prototype, "inputRef", void 0);
BInputNumberImpl = __decorate([
    Component({
        name: 'BInputNumber',
        model: {
            prop: 'value',
            event: 'update',
        },
    })
], BInputNumberImpl);
export { BInputNumberImpl };
